module.exports = require("@angular-devkit/build-webpack");